import React from 'react';

const ConsentPopup = ({ onAccept, onDecline }) => {
  return (
    <div className="popup-overlay">
      <div className="popup-content">
        <h2>Terms of Use</h2>
        <p>
            The data and information provided on this portal are intended for research purposes only and should not be used for making any clinical decisions, diagnoses, or providing clinical care. The content on this platform is not a substitute for professional medical advice, diagnosis, or treatment. While every effort has been made to ensure the accuracy and reliability of the data, errors or inaccuracies may still be present. Users are solely responsible for verifying the content and ensuring its suitability for their intended use. The administrators, contributors, and operators of this portal disclaim any liability for damages or losses arising from the use or misuse of the information provided. By accessing and using this portal, you acknowledge and agree that the data is for research purposes only and that you assume full responsibility for its application and interpretation. Always consult a qualified healthcare professional for any clinical or medical concerns.
        </p>
        <div className="popup-buttons">
          <button 
            className="accept-button" 
            onClick={onAccept}
          >
            I agree and acknowledge
          </button>
          <button 
            className="decline-button" 
            onClick={onDecline}
          >
            I disagree
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConsentPopup;